<script>
import SuppliersApi from '@/api/suppliers'
import SuppliersForm from './SuppliersForm'

export default {
  extends: SuppliersForm,

  mixins: [SuppliersApi],

  data() {
    return {
      isNew: false

    }
  },

  computed: {
    warningButtonText() {
      if (this.isManager) {
        return null
      }

      return this.form.disabled_comment ? 'Разблокировать': 'Заблокировать'
    }
  },

  created() {
    this.getSupplier(this.$route.params.id).then(response => {
      this.form = {
        ...response,
        x5_login: response.secret_access && response.x5_login === null ?
          this.secretAccessPlaceholder :
          response.x5_login,
        x5_pass: response.secret_access && response.x5_pass === null ?
          this.secretAccessPlaceholder :
          response.x5_pass
      }

      this.setInitFormData(this.form)

      this.initialSecretAccess = response.secret_access
    })
  },

  methods: {
    handleBlockSupplierClick() {
      if (!this.form.disabled_comment) {
        this.isShowDialog = true
      } else {
        this.changeStatus()
      }
    },

    changeStatus(message) {
      if (!this.form.disabled_comment && message.length < this.minMessageLength) {
        return
      }

      this.form.disabled_comment = message || ''

      this.isSubmit = true

      return this.changeSupplierStatus(this.form.id, this.form)
        .then(() => {
          window.snackbar( `Поставщик ${this.form.disabled_comment ? 'заблокирован' : 'разблокирован' }`, 'info')
        }).finally(() => {
          this.isSubmit = false
          this.isShowDialog = false
        })
    },

    handleFormSubmit() {
      if (this.isManager) {
        this.changeWerks()
        return
      }

      if (this.$v.$invalid) {
        this.$refs.form.validate()
        window.snackbar('Ошибки в форме', 'error')
        return
      }

      const params = {
        ...this.form,
        disabled_comment: null,
        x5_login: this.form.x5_login === this.secretAccessPlaceholder ? null : this.form.x5_login,
        x5_pass: this.form.x5_pass === this.secretAccessPlaceholder ? null : this.form.x5_pass
      }

      this.isSubmit = true

      window.confirm({
        title: 'Вы уверены, что хотите сохранить изменения?',
        confirmCallback: () => {
          this.updateSupplier(this.form.id, params)
            .then(() => {
              this.successSubmit({ message: 'Поставщик успешно изменен', routeName: 'suppliers' })
            })
            .finally(() => { this.afterSubmit() })
        },
        confirmText: 'Да',
        cancelText: 'Нет'
      })

      this.isSubmit = false
    },

    changeWerks() {
      this.$apiMethods.suppliers
        .changeWerks(this.form.id, this.form.werk_ids || [])
        .then(() => {
          window.snackbar('Поставщик успешно изменен', 'info')
          this.checkChangesBeforeLeave = false
          this.$router.push({ name: 'suppliers' })
        })
    }
  }
}
</script>
